<template>
  <div class="create-password-form">
    <a-form layout="vertical" :form="form" @submit="handleSubmit">
      <a-form-item label="Contraseña" has-feedback>
        <a-input-password
          v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: 'Este campo es requerido.',
                },
                {
                  min: 8,
                  message: '8 caracteres a más.',
                },
                {
                  pattern: /[A-Z]/g,
                  message: '1 carácter en mayúscula.',
                },
                {
                  pattern: /[a-z]/g,
                  message: '1 carácter en minúscula.',
                },
                {
                  pattern: /[0-9]/g,
                  message: '1 número.',
                },
                {
                  pattern: /[^A-Za-z0-9]/g,
                  message: '1 carácter especial',
                },
                {
                  validator: validateToNextPassword,
                },
              ],
            },
          ]"
          placeholder="Escribir nueva contraseña"
          :size="inputs_size"
        />
      </a-form-item>
      <a-form-item label="Confirmar contraseña" has-feedback>
        <a-input-password
          placeholder="Escribir nueva contraseña"
          v-decorator="[
            'confirm',
            {
              rules: [
                {
                  required: true,
                  message: 'Por favor confirme su contraseña',
                },
                {
                  validator: compareToFirstPassword,
                },
              ],
            },
          ]"
          @blur="handleConfirmBlur"
          @input="onInputConfirm"
          :size="inputs_size"
        />
      </a-form-item>
      <a-button
        type="primary"
        html-type="submit"
        style="width: 100%; margin-top: 4%"
        :loading="loadingBtn"
        :disabled="disabledBtn"
        :size="buttons_size"
        >Crear contraseña</a-button
      >
    </a-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CreatePasswordForm',
  props: {
    username: { type: String },
    email: { type: String },
  },
  data: () => ({
    confirmDirty: false,
    autoCompleteResult: [],
    submit: false, // acompañan a handleSubmit para evitar mas de 1 enter . se obliga a entrar en el primer if en el primer de handlesubmit
    loadingBtn: false,
    disabledBtn: true,
  }),
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'register' })
  },
  computed: {
    ...mapGetters(['buttons_size', 'inputs_size']),
  },
  methods: {
    ...mapActions(['verifyCompany', 'initSession']),
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          if (!this.submit) {
            this.submit = true
            this.loadingBtn = true
            const response = await this.verifyCompany({
              token: this.$route.query.token,
              password: values.password,
              username: this.username,
              email: this.email,
            })
            this.loadingBtn = false
            if (response.success === true) {
              this.$message.success('Contraseña creada correctamente')
              this.initSession(response.token)
            } else {
              this.form.resetFields()
              this.$message.error(response.result)
            }
            return (this.submit = false)
          } else {
            return
          }
        }
      })
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback('La contraseña nueva no coincide')
        this.disabledBtn = true
      } else {
        callback()
        this.disabledBtn = false
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    onInputConfirm(e) {
      const value = e.target.value
      if (value.length == 0) this.disabledBtn = true
    },
  },
}
</script>
<style lang="sass" scoped>
.password-form
  // min-width: 349px
  width: 349px
  height: 253px
</style>
<style lang="sass">
.ant-form-explain
  text-align: left
</style>
